import { routes } from '../../../routes/mainRoutes';

const loginOptions = [
  {
    id: 'loginFormEmail',
    name: 'email',
  },
  {
    id: 'loginFormPassword',
    name: 'password',
    type: 'password',
  },
];

const registerOptions = [
  {
    id: 'registerFormEmail',
    name: 'email',
  },
  {
    id: 'registerFormPassword',
    name: 'password',
    type: 'password',
  },
  {
    id: 'registerFormConfirm',
    name: 'confirmPassword',
    type: 'password',
  },
];

const sendEmailOptions = [
  {
    id: 'sendEmailFormEmail',
    name: 'sendEmail',
  },
];

const newPasswordOptions = [
  {
    id: 'newPasswordFormPassword',
    name: 'newPassword',
    type: 'password',
  },
  {
    id: 'newPasswordFormConfirm',
    name: 'newConfirm',
    type: 'password',
  },
];

const getFormOptions = url =>
  url === routes.LOGIN
    ? loginOptions
    : url === routes.REGISTER
    ? registerOptions
    : url === routes.SEND_EMAIL
    ? sendEmailOptions
    : url === routes.RESET_PASSWORD
    ? newPasswordOptions
    : [];

export { getFormOptions };
